<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{mode}}] {{$t('ipb')}}
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Create IPB" class="p-button-help" @click="simulateData" v-if="hasChecked && activeIndex == 1 && mode!=$FORM_MODE_DELETE"/>
                        <Button icon="pi pi-save" label="Save" class="p-button-success mr-2" @click="confirm($event,'ipb')" v-if="activeIndex == 2 && hasChecked && mode!=$FORM_MODE_DELETE" />
                        <Button icon="pi pi-plus" label="Create/Edit STO" class="p-button-warning mr-2" @click="simulateIpbSto(null)" v-if="ipbModel && allowStoSpo && activeIndex==2 && mode==$FORM_MODE_EDIT"/>
                        <Button icon="pi pi-plus" label="Create/Edit SPO" class="p-button-help" @click="simulateIpbSpo(null)" v-if="ipbModel && hasChecked && activeIndex==2 && mode==$FORM_MODE_EDIT"/>
                        <Button icon="pi pi-trash" label="Delete STO" class="p-button-danger mr-2" @click="simulateIpbSto($FORM_MODE_DELETE)" v-if="ipbModel && hasChecked && activeIndex==2 && mode==$FORM_MODE_DELETE"/>
                        <Button icon="pi pi-trash" label="Delete SPO" class="p-button-danger mr-2" @click="simulateIpbSpo($FORM_MODE_DELETE)" v-if="ipbModel && hasChecked && activeIndex==2 && mode==$FORM_MODE_DELETE"/>
                        <Button icon="pi pi-save" label="Save STO" class="p-button-success mr-2" @click="confirm($event,'sto')" v-show="activeIndex == 3 && stoModel" :disabled="saveSuccess"/>
                        <Button icon="pi pi-save" label="Save SPO" class="p-button-success" @click="confirm($event,'spo')" v-show="(activeIndex == 4 || (!stoModel && activeIndex==3)) && spoModel"/>
                        <ConfirmPopup/>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-8">
                            <FormField :labelName="$t('ipb_no')" fieldName="IPB_No" v-model="ipbModel.Document_No" v-if="ipbModel && mode != $FORM_MODE_CREATE" labelClass="col-2 ml-3" fieldClass="col-4">
                                <InputText name="Document_No" type="text" disabled v-model="ipbModel.Document_No" v-if="ipbModel && mode != $FORM_MODE_CREATE"/>
                            </FormField>
                        </div>
                    </div>

                    <TabView v-model:activeIndex="activeIndex">
                        <TabPanel header="Filter">
                            <div class="col-12">
                                <Message severity="error" :closable="true" v-if="filterMessage" @close="closeFilterMessage">{{filterMessage}}</Message>

                                <FormField :labelName="$t('filter_order_ipb')" fieldName="filter_order_type" v-model="order_type" :skeleton="false" :required="true" >
                                    <CustomSelect v-model="filter_order_type" :url="$API_URL + 'list/order_type_code'" :minLength="0" :params="{ use_ipb: true, transfer_type:$TRANSFER_TYPE.IN }" :disabled="mode != $FORM_MODE_CREATE"/>
                                </FormField>

                                <FormField :labelName="$t('filter_by')" fieldName="Filter_By" v-model="filter_by" :skeleton="false" :required="true" >
                                    <CustomSelect v-model="filter_by" :url="$API_URL + 'list/lookup'" :minLength="0" :params="{ group: $LOOKUP_GROUP.IPB_FILTER_BY }" @change="onChangeFilterBy" :disabled="mode != $FORM_MODE_CREATE"/>
                                </FormField>

                                <div v-if="filter_by">
                                    <div class="grid">
                                        <div class="col-6">
                                            <FormField :labelName="$t('order_no')" fieldName="filter_order_no" v-model="filter_order_no" :skeleton="false" labelClass="col-4" fieldClass="col-6 md-6" >
                                                <CustomChips v-model="filter_order_no" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                                            </FormField>

                                            <FormField :labelName="$t('sap_no')" fieldName="filter_sap_no" v-model="filter_sap_no" :skeleton="false" labelClass="col-4" fieldClass="col-6 md-6">
                                                <CustomChips v-model="filter_sap_no" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                                            </FormField>

                                            <FormField :labelName="$t('shipment_no')" fieldName="filter_shipment_no" v-model="filter_shipment_no" :skeleton="false" labelClass="col-4" fieldClass="col-6 md-6">
                                                <CustomChips v-model="filter_shipment_no" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                                            </FormField>

                                            <FormField :labelName="$t('sto_no')" fieldName="filter_sto_no" v-model="sto_no" :skeleton="false" labelClass="col-4" fieldClass="col-6 md-6">
                                                <CustomChips v-model="filter_sto_no" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                                            </FormField>

                                            <FormField :labelName="$t('spo_no')" fieldName="filter_spo_no" v-model="spo_no" :skeleton="false" labelClass="col-4" fieldClass="col-6 md-6">
                                                <CustomChips v-model="filter_spo_no" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                                            </FormField>


                                            <FormField :labelName="$t('distribution')" fieldName="filter_distribution" v-model="filter_distribution" :skeleton="false" :required="true" labelClass="col-4" fieldClass="col-6 md-6">
                                                 <CustomMultiSelect 
                                                    v-model="filter_distribution" 
                                                    :url="this.$API_URL + 'list/lookup'" 
                                                    :minLength="0" 
                                                    :params="{ group: $LOOKUP_GROUP.DISTRIBUTION }" />
                                            </FormField>

                                            <FormField :labelName="$t('commodity_group')" fieldName="filter_commodity_group" v-model="filter_commodity_group" :skeleton="false" :required="true" labelClass="col-4" fieldClass="col-6 md-6">
                                                 <CustomMultiSelect 
                                                    v-model="filter_commodity_group" 
                                                    :url="this.$API_URL + 'list/commodity_group'" 
                                                    :minLength="0" 
                                                    :params="{}" />
                                            </FormField>
                                        </div>
                                        <div class="col-6">
                                            <FormField :labelName="$t('transporter')" fieldName="filter_transporter" v-model="filter_loading" :skeleton="false" labelClass="col-4" :required="true" fieldClass="col-6 md-6">
                                                <CustomSelect class="p-inputtext-sm" v-model="filter_transporter" :url="this.$API_URL + 'list/transporter_all'" :filter="true" :minLength="0" :params="{ }" />
                                            </FormField>

                                            <FormField :labelName="$t('loading')" fieldName="filter_loading" v-model="filter_loading" :skeleton="false" labelClass="col-4" :required="true" fieldClass="col-6 md-6">
                                                <CustomSelect class="p-inputtext-sm" v-model="filter_loading" :url="this.$API_URL + 'list/location_code'" :filter="true" :minLength="0" :params="{ }" />
                                            </FormField>

                                            <FormField :labelName="$t('destination')" fieldName="filter_destination" v-model="filter_destination" :skeleton="false" labelClass="col-4" :required="true" fieldClass="col-6 md-6">
                                                <CustomSelect class="p-inputtext-sm" v-model="filter_destination" :url="this.$API_URL + 'list/location_code'" :filter="true" :minLength="0" :params="{ }" />
                                            </FormField>

                                            <FormField :labelName="$t('doc_date')" fieldName="filter_date" v-model="filter_date" :skeleton="false" :required="true" labelClass="col-4" fieldClass="col-6 md-6">
                                                <DatePicker dateFormat="dd/mm/yy" class="p-inputtext-sm" v-model="filter_date" selectionMode="range"/>
                                            </FormField>

                                            <FormField :labelName="$t('company')" fieldName="filter_company" v-model="filter_company" :skeleton="false" :required="true" labelClass="col-4" fieldClass="col-6 md-6">
                                                <CustomSelect class="p-inputtext-sm" v-model="filter_company" :url="this.$API_URL + 'list/company_code'" :filter="true" :minLength="0" :params="{ }" />
                                            </FormField>

                                            <!-- <FormField :labelName="$t('order_type')" fieldName="filter_order_type" v-model="filter_order_type" :skeleton="false" :required="true" labelClass="col-4" fieldClass="col-6 md-6">
                                                <CustomSelect class="p-inputtext-sm" v-model="filter_order_type" :url="this.$API_URL + 'list/order_type_code'" :minLength="0" :params="{ }" />
                                            </FormField> -->

                                            <FormField :labelName="$t('document_type')" fieldName="filter_document_type" v-model="filter_document_type" :required="true" :skeleton="false" labelClass="col-4" fieldClass="col-6 md-6" >
                                                <CustomSelect class="p-inputtext-sm" v-model="filter_document_type" :url="this.$API_URL + 'list/lookup'" :filter="true" :minLength="0" :params="{ group: $LOOKUP_GROUP.DOCUMENT_TYPE }" />
                                            </FormField>
                                        </div>
                                    </div>

                                    <FormField :labelName="''" fieldName="" v-model="filter_order_type" :skeleton="false" fieldClass="col-2">
                                        <Button class="p-button-primary" label="Filter" @click="filterData"/>
                                    </FormField> 
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Result">
                            <DataTable 
                                ref="dt" 
                                v-model:expandedRows="expandedRowsEdit"
                                @rowExpand="onRowExpandEdit"
                                responsiveLayout="scroll" 
                                class="p-datatable-sm"
                                :value="result_data_edit"
                                :totalRecords="result_data_edit.length"
                                v-if="mode != $FORM_MODE_CREATE"
                                >
                                <Column :expander="true" field="" header="">
                                </Column>
                                <Column field="Ref_No" :header="$t('ref_no')">
                                </Column>
                                <Column field="WB_Ref_No" :header="$t('wb_ref_no')" v-if="useShipmentHeader">
                                </Column>
                                <Column field="WB_Report_Date" :header="$t('wb_report_date')" dataType="date" v-if="useShipmentHeader">
                                    <template #body="slotProps">
                                        {{$formatDate(slotProps.data.WB_Report_Date)}}
                                    </template>
                                </Column>
                                <Column field="Document_Date" :header="$t('doc_date')"  dataType="date" v-if="!useShipment">
                                    <template #body="slotProps">
                                        {{$formatDate(slotProps.data.Document_Date)}}
                                    </template>
                                </Column>
                                <Column field="Transporter_Code" :header="$t('transporter')" dataType="text">
                                </Column>
                                <Column field="loading_destination_from_name" :header="$t('loading')">
                                </Column>
                                <Column field="loading_destination_to_name" :header="$t('destination')">
                                </Column>
                                <Column field="Freight_Cost" :header="$t('freight_cost')">
                                </Column>
                                <Column field="number_of_trip" :header="$t('number_trip')">
                                </Column>
                                <Column field="Truck_Type" :header="$t('truck_type')">
                                </Column>
                                <Column field="shipment_type_name" :header="$t('shipment_type')">
                                </Column>
                                <Column field="Incoterm" :header="$t('incoterm')">
                                </Column>
                                <template #expansion="slotProps">
                                    <div class="orders-subtable">
                                        <DataTable :value="slotProps.data.Details" class="p-datatable-sm"  responsiveLayout="scroll" >
                                            <Column field="WB_Ref_No" :header="$t('wb_ref_no')" v-if="useShipmentDetail"></Column>
                                            <Column field="WB_Report_Date" :header="$t('wb_report_date')" dataType="date" v-if="useShipmentDetail">
                                                <template #body="slotProps">
                                                    {{$formatDate(slotProps.data.WB_Report_Date)}}
                                                </template>
                                            </Column>
                                            <Column field="Order_No" :header="$t('order_no')" v-if="useShipment"></Column>
                                            <Column field="Order_Item_No" :header="$t('order_item_no')" v-if="useShipment"></Column>
                                            <Column field="SAP_No" :header="$t('sap_no')" ></Column>
                                            <Column field="SAP_Item_No" :header="$t('sap_item_no')" ></Column>
                                            <Column field="material_name" :header="$t('material')" class="w-6"></Column>
                                            <Column field="Qty" :header="$t('qty')">
                                                <template #body="{data}">
                                                    {{ $formatNumber(data.Qty)}}
                                                </template>
                                            </Column>
                                            <Column field="UOM" :header="$t('uom')"></Column>
                                            <Column field="STO_No" :header="$t('sto_no')" class="w-2"></Column>
                                            <Column field="STO_Item_No" :header="$t('sto_item_no')" class="w-2"></Column>
                                            <Column field="Without_Price" :header="$t('without_price')" class="w-2"></Column>
                                            <Column field="SPO_No" :header="$t('spo_no')" class="w-2"></Column>
                                            <Column field="SPO_Item_No" :header="$t('spo_item_no')" class="w-2" ></Column>
                                        </DataTable>
                                    </div>
                                </template>
                            </DataTable>

                            <Message severity="error" :closable="true" v-if="simulateMessage" class="mt-2">{{simulateMessage}}</Message>
                            <DataTable 
                                ref="dt" 
                                v-model:expandedRows="expandedRows"
                                @rowExpand="onRowExpand"
                                responsiveLayout="scroll" 
                                class="p-datatable-sm mt-1"
                                :value="result_data"
                                :loading="filtering"
                                :totalRecords="result_data.length"
                                :rowClass="authRowClass"
                                >
                                <Column :expander="true" field="" header="">
                                    <template #header="">
                                        <Button :icon="allExpanderIcon" class="p-button-rounded p-button-text" @click="onExpandAll"/>
                                    </template>
                                </Column>
                                <Column :exportable="false" :sortable="false">
                                    <template #header="">
                                        <Checkbox v-model="check_all" :binary="true" @input="onCheckAll" />
                                    </template>
                                    <template #body="slotProps">
                                        <Checkbox v-model="slotProps.data.is_checked" :binary="true" :disabled="slotProps.data.disabled" />
                                    </template>
                                </Column>
                                <Column field="Ref_No" :header="$t('ref_no')">
                                </Column>
                                <Column field="WB_Ref_No" :header="$t('wb_ref_no')" v-if="useShipmentHeader">
                                </Column>
                                <Column field="WB_Report_Date" :header="$t('wb_report_date')" dataType="date" v-if="useShipmentHeader">
                                    <template #body="slotProps">
                                        {{$formatDate(slotProps.data.WB_Report_Date)}}
                                    </template>
                                </Column>
                                <Column field="Document_Date" :header="$t('doc_date')"  dataType="date" v-if="!useShipment">
                                    <template #body="slotProps">
                                        {{$formatDate(slotProps.data.Document_Date)}}
                                    </template>
                                </Column>
                                <Column field="Transporter_Code" :header="$t('transporter')" dataType="text">
                                </Column>
                                <Column field="loading_destination_from_name" :header="$t('loading')">
                                </Column>
                                <Column field="loading_destination_to_name" :header="$t('destination')">
                                </Column>
                                <Column field="Freight_Cost" :header="$t('freight_cost')">
                                </Column>
                                <Column field="number_of_trip" :header="$t('number_trip')">
                                </Column>
                                <Column field="Truck_Type" :header="$t('truck_type')">
                                </Column>
                                <Column field="shipment_type_name" :header="$t('shipment_type')">
                                </Column>
                                <Column field="Incoterm" :header="$t('incoterm')">
                                </Column>
                                <template #expansion="slotProps">
                                    <div class="orders-subtable">
                                        <DataTable :value="slotProps.data.Details" class="p-datatable-sm"  responsiveLayout="scroll" >
                                            <Column field="WB_Ref_No" :header="$t('wb_ref_no')" v-if="useShipmentDetail"></Column>
                                            <Column field="WB_Report_Date" :header="$t('wb_report_date')" dataType="date" v-if="useShipmentDetail">
                                                <template #body="slotProps">
                                                    {{$formatDate(slotProps.data.WB_Report_Date)}}
                                                </template>
                                            </Column>
                                            <Column field="Order_No" :header="$t('order_no')" v-if="useShipment"></Column>
                                            <Column field="Order_Item_No" :header="$t('order_item_no')" v-if="useShipment"></Column>
                                            <Column field="SAP_No" :header="$t('sap_no')" ></Column>
                                            <Column field="SAP_Item_No" :header="$t('sap_item_no')" ></Column>
                                            <Column field="material_name" :header="$t('material')" class="w-6"></Column>
                                            <Column field="Qty" :header="$t('qty')">
                                                <template #body="{data}">
                                                    {{ $formatNumber(data.Qty)}}
                                                </template>
                                            </Column>
                                            <Column field="UOM" :header="$t('uom')"></Column>
                                            <Column field="STO_No" :header="$t('sto_no')" class="w-2"></Column>
                                            <Column field="STO_Item_No" :header="$t('sto_item_no')" class="w-2"></Column>
                                            <Column field="Without_Price" :header="$t('without_price')" class="w-2"></Column>
                                            <Column field="SPO_No" :header="$t('spo_no')" class="w-2"></Column>
                                            <Column field="SPO_Item_No" :header="$t('spo_item_no')" class="w-2" ></Column>
                                        </DataTable>
                                    </div>
                                </template>
                            </DataTable>
                        </TabPanel>
                        <TabPanel :header="$t('ipb')" v-if="ipbModel != null">
                            <IPB :ipbmodel="ipbModel" :conditionmodel="conditionModel" :defaultconditionmodel="defaultConditionsModel" :defaultdetailmodel="defaultDetailsModel" v-if="ipbModel!= null" :mode="mode" />
                        </TabPanel>
                        <TabPanel :header="$t('sto')" v-if="stoModel!=null">
                            <STO 
                                :stomodel="stoModel"
                                :conditionmodel="conditionModel" 
                                :defaultconditionmodel="defaultConditionsModel"
                                :defaultdetailmodel="defaultDetailsModel"
                                v-if="stoModel!= null"
                                :mode="this.ipbModel.mode" 
                                @block-ui="blockUI"
                                @unblock-ui="unblockUI"
                                @change-model="onChangeModel($event)"/>
                        </TabPanel>
                        <TabPanel :header="$t('spo')" v-if="spoModel != null">
                            <SPO 
                                :spomodel="spoModel" 
                                :conditionmodel="conditionModel" 
                                v-if="spoModel!= null" 
                                :mode="this.ipbModel.mode" 
                                :servicemodel="serviceModel"
                                :materialinfomodel="materialInfoModel"
                                :simulatemodel="simulateModel"
                                @block-ui="blockUI"
                                @unblock-ui="unblockUI"
                                @change-simulate-model="onChangeSimulateModel($event)"
                                ref="spoTab"
                                />
                        </TabPanel>
                        <TabPanel :header="$t('result_data_sap')" v-if="saveSuccess">
                            <Result :resultModel="stoSpoResultModel" v-if="stoSpoResultModel != null && saveSuccess" />
                        </TabPanel>
                    </TabView>
                </div>
                
            </template>
        </Card>
    </form>
</template>

<script>
    import Data from './_Data.vue'
    import IPB from './_IPB.vue'
    import Result from './_Result.vue'
    import STO from '../STO/_STO.vue'
    import SPO from '../SPO/_SPO.vue'

    export default {
        name: "Editor",
        components:{
            Data: Data,
            IPB: IPB,
            Result: Result,
            STO: STO,
            SPO: SPO
        },
        data() {
            return {
                indexName: "IPBIndex",
                url: this.$API_URL + "ipb/",
                stoUrl: this.$API_URL + "sto/",
                spoUrl: this.$API_URL + "spo/",
                header: null,
                detail: null,
                stoModel: null,
                spoModel:null,
                mode: "",
                id: 0,
                activeIndex: 0,
                filtering: false,
                formEditable: true,

                result_data: [],
                check_all: false,
                expandedRows: [],
                allExpanderIcon:"pi pi-fw pi-chevron-down",
                expandAll: false,

                result_data_edit: [],
                expandedRowsEdit: [],

                filterMessage: "",
                simulateMessage: "",

                filter_by:"",
                filter_sap_no:[],
                filter_order_no:[],
                filter_shipment_no: [],
                filter_sto_no: [],
                filter_spo_no: [],
                filter_transporter: "",
                filter_distribution: [],
                filter_commodity_group: [],
                filter_loading: "",
                filter_destination: "",
                filter_date: [],
                filter_company: "",
                filter_order_type: "",
                filter_document_type: "",

                useShipmentHeader: true,
                useShipmentDetail: true,
                ipbModel: null,
                conditionModel: null,
                defaultConditionsModel: [],
                defaultDetailsModel: [],
                serviceModel:[],
                simulateModel:[],
                stoSpoResultModel: null,
                saveSuccess: false

            }
        },
        methods: {
            blockUI(){
                this.$emit('block-ui');
            },
            unblockUI(){
                this.$emit('unblock-ui');
            },
            onExpandAll(){
                if(this.result_data.length == 0)
                    return;

                if(this.expandAll){
                    this.expandedRows = [];
                    this.allExpanderIcon = "pi pi-fw pi-chevron-down";
                }
                else{
                    for(var i=0; i<this.result_data.length;i++){
                        this.expandedRows.push(this.result_data[i]);
                    }
                    this.allExpanderIcon = "pi pi-fw pi-chevron-up";
                }

                this.expandAll = !this.expandAll;
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            onRowExpandEdit(event){
                this.expandedRowsEdit = [];
                this.expandedRowsEdit.push(event.data);
            },
            getData() {
                var self = this;
                this.$axios.get(this.url + this.id + "/" + this.mode)
                    .then((response) => {
                        self.ipbModel = response.data.data.header;
                        self.ipbModel.mode = self.mode;
                        self.conditionModel = response.data.data.condition;

                        if(self.mode != self.$FORM_MODE_CREATE)
                        {
                            self.result_data_edit = response.data.data.edit_filter;   
                            self.defaultConditionsModel = response.data.data.default_conditions;
                            self.defaultDetailsModel = response.data.data.default_details;
                            self.filter_by = self.ipbModel.Filter_By;
                            self.filter_order_type = self.ipbModel.Order_Type;
                        }

                        if(self.ipbModel.Filter_By == this.$FILTER_BY.SHIPMENT_COLLECTIVE && self.ipbModel.Order_Type == this.$ORDER_TYPE.IPB){
                            self.useShipmentHeader = true;
                            self.useShipmentDetail = true;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            saveData() {
                this.$emit('block-ui');
                var self = this;
                this.ipbModel.mode = this.mode;
                this.$axios.post(this.url + "save_ipb", this.ipbModel)
                    .then((response) => {
                        if (response.data.success) {
                            self.stoResultMmodel = response.data.data;
                            this.$toast.add({ severity: 'success', summary: "Success", detail: "", life: 120000});
                            this.backToIndex()
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            saveSto() {
                this.$emit('block-ui');
                var self = this;
                this.stoModel.mode = this.$FORM_MODE_CREATE;
                console.log(this.stoModel)
                this.$axios.post(this.stoUrl + "save_sto", this.stoModel)
                    .then((response) => {
                        if (response.data.success) {
                            self.stoSpoResultModel = response.data.data;
                            self.$emit('unblock-ui');
                            self.$toast.add({ severity: 'success', summary: "Save STO Success", detail: response.data.message, life: 120000});
                            self.activeIndex = 3;
                            self.saveSuccess = true;
                            //self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000 } } );
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            saveSpo() {
                this.$emit('block-ui');
                var self = this;
                this.spoModel.mode = this.$FORM_MODE_CREATE;
                this.$axios.post(this.spoUrl + "save_spo", this.spoModel)
                    .then((response) => {
                        if (response.data.success) {
                            self.stoSpoResultModel = response.data.data;
                            self.$emit('unblock-ui');
                            self.$toast.add({ severity: 'success', summary: "Save STO Success", detail: response.data.message, life: 120000});
                            self.activeIndex = 3;
                            self.saveSuccess = true;
                            //self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000 } } );
                        }
                        else {
                            self.showError('Error Saving Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Saving Data', error);
                    });
            },
            showError(summary, message) {
                this.$emit('unblock-ui');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            backToIndex() {
                this.unlockTransaction();
                this.$router.push({ path: "/IPB/Index" });
            },
            confirm(event,category) {
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'Are you sure?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        switch(category){
                            case 'ipb':{
                                this.saveData();
                                break;
                            }
                            case 'sto':{
                                this.saveSto();
                                break;
                            }
                            case 'spo':{
                                this.saveSpo();
                                break;
                            }
                        }
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                    }
                });
            },
            filterData(){
                if(this.filter_order_no.length == 0 && this.filter_sap_no.length == 0 && (!this.useShipment || (this.useShipment && this.filter_shipment_no.length == 0))){
                    if(this.filter_distribution.length == 0){
                        this.showError("Validation error", this.$t('alert.require_distribution'));
                        return;
                    }

                    if(this.filter_commodity_group.length == 0){
                        this.showError("Validation error", this.$t('alert.require_commodity_group'));
                        return;
                    }

                    if(this.filter_transporter == ""){
                        this.showError("Validation error", this.$t('alert.require_transporter'));
                        return;
                    }

                    if(this.filter_loading == ""){
                        this.showError("Validation error", this.$t('alert.require_loading'));
                        return;
                    }

                    if(this.filter_destination == ""){
                        this.showError("Validation error", this.$t('alert.require_destination'));
                        return;
                    }

                    if(this.filter_date.length == 0){
                        this.showError("Validation error", this.$t('alert.require_document_date'));
                        return;
                    }

                    if(this.filter_company == ""){
                        this.showError("Validation error", this.$t('alert.require_company'));
                        return;
                    }

                    if(this.filter_order_type == ""){
                        this.showError("Validation error", this.$t('alert.require_order_type'));
                        return;
                    }

                    if(this.filter_document_type == ""){
                        this.showError("Validation error", this.$t('alert.require_document_type'));
                        return;
                    }

                }

                this.filtering = true;

                this.$emit('block-ui');
                this.filterMessage = "";

                
                var self = this;
                this.$axios.post(this.url + "filter", this.filterDataModel)
                    .then((response) => {
                        if (response.data.success) {
                            //this.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                            self.result_data = response.data.data;
                            self.activeIndex = 1;
                            self.$emit("unblock-ui");
                        }
                        else {
                            self.filterMessage = response.data.message;
                            self.$emit("unblock-ui");
                            //self.showError('Error Filtering Data', response.data.message);
                        }
                        self.filtering = false;
                    })
                    .catch(function (error) {
                        self.showError('Error Filtering Data', error);
                        self.$emit("unblock-ui");
                        self.filtering = false;
                    });

            },
            onCheckAll(event){
                //console.log(event);
                if(this.result_data.length > 0){
                    for(var i=0; i< this.result_data.length;i++){
                        if(!this.result_data[i].disabled)
                            this.result_data[i].is_checked = event;
                    }            
                }
            },
            onPaste(event, type){
                
            },
            reset(){
                this.filter_by = this.$FILTER_BY.SHIPMENT_COLLECTIVE;
                this.filter_sap_no = [];
                this.filter_order_no = [];
                this.filter_shipment_no = [];
                this.filter_sto_no = [];
                this.filter_spo_no = [];
                this.filter_transporter = "";
                this.filter_distribution = [];
                this.filter_commodity_group = [];
                this.filter_loading = "";
                this.filter_destination = "";
                this.filter_date = [];
                this.filter_company = "";
                this.filter_order_type = this.$ORDER_TYPE_NAME.IPB_IN;
                this.filter_document_type = "";

                this.result_data = [];
                this.result_data_edit = [];
            },
            closeFilterMessage(event){
                this.filterMessage = "";
            },
            authRowClass(data){
                return data.disabled ? "row-unauthorized" : "";
            },
            onChangeFilterBy(event){
                if(event){
                    this.useShipmentHeader = false;
                    this.useShipmentDetail = false;
                    
                    if(event.id == this.$FILTER_BY.SHIPMENT_COLLECTIVE && this.filter_order_type == this.$ORDER_TYPE.IPB){
                        this.useShipmentHeader = true;
                    }
                    else if(event.id == this.$STO_FILTER_BY.SHIPMENT){
                        this.useShipmentDetail = true;
                    }
                    else if(event.id == this.$STO_FILTER_BY.WBREF){
                        this.useShipmentHeader = true;
                    }
                }
            },
            simulateData(){
                var self = this;

                this.$emit("block-ui");
                
                var simulateData = {
                    models:this.result_data,
                    existing_model: (self.ipbModel && self.ipbModel.mode == self.$FORM_MODE_EDIT?self.ipbModel:null)
                }
                console.log(simulateData)
                this.$axios.post(this.url + "simulate", simulateData)
                    .then((response) => {
                        if (response.data.success) {
                            //this.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                            self.ipbModel = response.data.data.header;
                            self.conditionModel = response.data.data.condition;
                            self.defaultConditionsModel = response.data.data.default_conditons;
                            self.defaultDetailsModel = response.data.data.default_details;
                            self.activeIndex = 2;
                            self.$emit("unblock-ui");
                        }
                        else {
                            self.simulateMessage = response.data.message;
                            self.$emit("unblock-ui");
                            //self.showError('Error Filtering Data', response.data.message);
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Simulating Data', error);
                        self.$emit("unblock-ui");
                    });

            },
            simulateIpbSto(mode){
                this.$emit('block-ui');
                var self = this;
                this.ipbModel.mode = this.ipbModel.ListStoSpo.find(r=>r.is_checked)? (mode??self.$FORM_MODE_EDIT):self.$FORM_MODE_CREATE;
                this.$axios.post(this.url + "simulate_ipb_sto", this.ipbModel)
                    .then((response)=>{
                        this.$emit('unblock-ui');
                        this.stoModel = response.data.data.header
                        this.activeIndex = 3
                    })
                    .catch((err)=>{
                        self.showError('Error Saving Data', err);
                    })
            },
            simulateIpbSpo(mode){
                this.$emit('block-ui');
                var self = this;
                this.ipbModel.mode = this.ipbModel.ListStoSpo.find(r=>r.is_checked)? (mode??self.$FORM_MODE_EDIT):self.$FORM_MODE_CREATE;
                this.$axios.post(this.url + "simulate_ipb_spo", this.ipbModel)
                    .then((response)=>{
                        self.$emit('unblock-ui');
                        self.spoModel = response.data.data.header
                        self.conditionModel = response.data.data.condition;
                        self.defaultConditionsModel = response.data.data.default_conditons;
                        self.defaultDetailsModel = response.data.data.default_details;
                        self.simulateModel = response.data.data.simulate_list;
                        self.serviceModel = response.data.data.service_detail;
                        self.activeIndex = self.stoModel?4:3;
                    })
                    .catch((err)=>{
                        self.showError('Error Saving Data', err);
                    })
            },
            onChangeModel(data){
                this.stoModel = data;
                console.log(this.stoModel);
            },
            lockTransaction(){
                var self = this;

                var data = {
                    Transaction_Mode : self.mode,
                    Transaction_Type: self.$TRANSACTION_TYPE.IPB,
                    Transaction_Id: self.id
                };

                this.$emit("block-ui");

                self.simulateMessage = "";
                this.$axios.put(self.$UTIL_URL + "lock_transaction", data)
                    .then((response) => {
                        if (response.data.success) {

                        }
                        else {
                            self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'error', summary: 'Transaction Locked', detail: response.data.message, life: 120000} } );
                        }
                    })
                    .catch(function (error) {
                        self.showError('Error Simulating Data', error);
                        self.$emit("unblock-ui");
                    });
            },
            unlockTransaction(){
                var self = this;

                var data = {
                    Transaction_Mode : self.mode,
                    Transaction_Type: self.$TRANSACTION_TYPE.IPB,
                    Transaction_Id: self.id
                }

                 this.$axios.put(self.$UTIL_URL + "unlock_transaction", data)
                    .then((response) => {
                        if (response.data.success) {

                        }
                        else {
                            //self.$router.push({ name: this.indexName, params: { showToast: true, severity: 'error', summary: 'Transaction Locked', detail: response.data.message, life: 120000} } );
                        }
                    })
                    .catch(function (error) {
                        // self.showError('Error Simulating Data', error);
                        // self.$emit("unblock-ui");
                    });

            },
            leaving() {
                this.unlockTransaction();

                window.removeEventListener("beforeunload", this.leaving);
            },
        },
         beforeUnmount(){
            this.leaving();
        },
        created() {
            this.mode = this.$route.query.mode;
            this.id = this.$route.query.id ?? 0;
            this.reset();

            window.addEventListener("beforeunload", this.leaving);


            if(this.mode != this.$FORM_MODE_CREATE)
            {
                this.getData();
                this.lockTransaction();
            }
        },
        computed:{
            hasChecked(){
                if(this.activeIndex==1){
                    if(this.result_data == null || this.result_data.length <= 0)
                        return false;

                    return this.result_data.find(r=>r.is_checked);
                }
                else if(this.activeIndex==2){
                    if(this.ipbModel!=null && this.ipbModel.Details == null)
                        return false;

             
                    return this.ipbModel.Details.find(r=>r.is_checked)
                }
                return true;
            },
            allowStoSpo(){
                if(this.ipbModel!=null && this.ipbModel.Details == null || this.ipbModel.Details.find(r=>r.is_checked && r.Freight_Approval_Status != this.$APPROVAL_STATUS.APPROVED))
                        return false;
             
                var check = this.result_data
                    .find(r=>r.is_checked) ||
                        (
                            this.ipbModel!=null &&
                            (this.ipbModel.ListStoSpo.find(r=>r.is_checked) ||
                            this.ipbModel.Details.find(r=>r.is_checked))
                        );
                return check;
            },
            useShipment(){
                return this.useShipmentHeader || this.useShipmentDetail;
            },
            companyCodes(){
                return this.filter_company.length == 0? "" : this.filter_company.join(";");
            },
            plantCodes(){
                return this.filter_plant.length == 0? "" : this.filter_plant.join(";");
            },
            businessSegmentCodes(){
                return this.filter_product_category.length == 0? "" : this.filter_product_category.join(";");
            },
            filterDataModel(){
                var filter = {  
                    mode: this.mode,
                    filter_by: this.filter_by,
                    filter_sap_no: this.filter_sap_no,
                    filter_order_no: this.filter_order_no,
                    filter_shipment_no: this.filter_shipment_no,
                    filter_sto_no: this.filter_sto_no,
                    filter_spo_no: this.filter_spo_no,
                    filter_distribution: this.filter_distribution,
                    filter_commodity_group: this.filter_commodity_group,
                    filter_transporter: this.filter_transporter,
                    filter_loading: this.filter_loading,
                    filter_destination: this.filter_Destination,
                    filter_date_from: this.filter_date[0] ? this.filter_date[0] : null,
                    filter_date_to: this.filter_date[1] ? this.filter_date[1] : null,
                    filter_company: this.filter_company,
                    filter_order_type: this.filter_order_type,
                    filter_document_type: this.filter_document_type
                };  

                return filter;
            }
        }
    }
</script>
<style scoped>
    .p-inputtext-sm .p-inputtext {
        padding:0.25rem!important;
    }

    .p-chips .p-chips-multiple-container {
        padding: 0.25rem 0.5rem!important;
    }

    
</style>